module.exports = __webpack_public_path__ + "img/gzhj.548e4faf.png";